import { useMutation } from '@tanstack/react-query';
import { axiosClient } from '@/shared/apis/config';
import { ApiResponse } from '@/shared/types';

type ContentUrlsData = Record<string, string | null>;
export type PostContentUrlsResponse = ApiResponse<ContentUrlsData>;

export const postContentUrlsApi = async (
  contentIds: number[],
): Promise<PostContentUrlsResponse> => {
  try {
    const response = await axiosClient.post<PostContentUrlsResponse>(
      '/v1.0/content/urls',
      { contentIds },
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const usePostContentUrls = () => {
  return useMutation({
    mutationFn: postContentUrlsApi,
  });
};
